export default "__VITE_ASSET__BomJiCFm__"